/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OverwolfLauncherGameIdsResponse
 */
export interface OverwolfLauncherGameIdsResponse {
    /**
     * Overwolf gameId strings flagged as platform launchers.
     * @type {Array<string>}
     * @memberof OverwolfLauncherGameIdsResponse
     */
    gameIds: Array<string>;
}

/**
 * Check if a given object implements the OverwolfLauncherGameIdsResponse interface.
 */
export function instanceOfOverwolfLauncherGameIdsResponse(value: object): value is OverwolfLauncherGameIdsResponse {
    if (!('gameIds' in value) || value['gameIds'] === undefined) return false;
    return true;
}

export function OverwolfLauncherGameIdsResponseFromJSON(json: any): OverwolfLauncherGameIdsResponse {
    return OverwolfLauncherGameIdsResponseFromJSONTyped(json, false);
}

export function OverwolfLauncherGameIdsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverwolfLauncherGameIdsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'gameIds': json['gameIds'],
    };
}

export function OverwolfLauncherGameIdsResponseToJSON(json: any): OverwolfLauncherGameIdsResponse {
    return OverwolfLauncherGameIdsResponseToJSONTyped(json, false);
}

export function OverwolfLauncherGameIdsResponseToJSONTyped(value?: OverwolfLauncherGameIdsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameIds': value['gameIds'],
    };
}

